import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PrivacyPolicyPage from './PrivacyPolicyPage';

const msp = (state, ownProps) => ({});

const mdp = (dispatch) => ({});

export default withRouter(connect(msp, mdp)(PrivacyPolicyPage));
